export default {
  meta: {
    title: '复盘审核'
  }
};
